import styles from './ClassificationList.less';

import React, { Component, PropTypes } from 'react';

import RefineChecklist from 'RefineChecklist/RefineChecklist';
import { preventRenderingInClientIfNot } from 'prevent-rendering-if-not';

export default class ClassificationList extends Component {

  static propTypes = {
    classifications: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        displayCount: PropTypes.string,
        isActive: PropTypes.bool.isRequired,
        refineParams: PropTypes.object.isRequired
      })
    ).isRequired,
    path: PropTypes.string.isRequired,
    handleSelection: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
  };

  shouldComponentUpdate({ open }) {
    return open;
  }

  render() {
    const { classifications, path, handleSelection, open, ...props } = this.props;
    return (
      <nav {...props} role="navigation" data-automation="searchClassification">
        <h1 className={styles.heading}>Classifications</h1>
        {preventRenderingInClientIfNot(open) ?
          <RefineChecklist
            handleSelection={handleSelection}
            options={classifications}
            childrenKey="children"
            path={path}
          /> : null}
      </nav>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Search/components/SearchBar/components/ClassificationList/ClassificationList.js
 **/